import { productImageSwiper } from "../swiper_init/swiper.js"

$(document).on("turbolinks:load", function () {
  var $supportModal = $(".js-support-modal")

  $supportModal.on("show.bs.modal", function () {
    productImageSwiper.keyboard.disable()
  })

  $supportModal.on("hide.bs.modal", function () {
    productImageSwiper.keyboard.enable()
  })
})
